/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Agents_Use_3_ValueInputs */

const en_svc_agents_use_3_value = /** @type {(inputs: Svc_Agents_Use_3_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Routine questions get a prepared reply; anything unusual goes to a person.`)
};

const lv_svc_agents_use_3_value = /** @type {(inputs: Svc_Agents_Use_3_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikdienas jautājumiem tiek sagatavota atbilde; viss neparastais nonāk pie cilvēka.`)
};

/**
* | output |
* | --- |
* | "Routine questions get a prepared reply; anything unusual goes to a person." |
*
* @param {Svc_Agents_Use_3_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_agents_use_3_value = /** @type {((inputs?: Svc_Agents_Use_3_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Agents_Use_3_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_agents_use_3_value(inputs)
	return en_svc_agents_use_3_value(inputs)
});